function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import Icon from '../../icon';
import ButtonWrapper from '../button-wrapper';
import { CONTROL_SIZE_MAP } from '../../theme/scale';
const Wrapper = styled(ButtonWrapper)`
  ${({
  size
}) => size && `height: ${CONTROL_SIZE_MAP[size].height}; width: ${CONTROL_SIZE_MAP[size].height};`}
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
export const IconButton = ({
  icon,
  outlineIcon = false,
  variant = 'base',
  element = 'button',
  iconSize = 16,
  disabled = false,
  loading = false,
  id,
  size = 'md',
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, props, {
    size,
    variant,
    disabled,
    loading,
    id,
    forwardedAs: element,
    loaderSize: "xs"
  }), /*#__PURE__*/React.createElement(Icon, {
    decorative: true,
    type: icon,
    outlined: outlineIcon,
    size: iconSize
  }));
};
export default IconButton;
//# sourceMappingURL=index.js.map